export class Utils {
  static toLocalDateTime(datetime: string) {
    // Server returns UTC datetimes without a timezone suffix.
    // Appending 'Z' tells the browser to treat the value as UTC,
    // so it converts to local time (including DST) automatically.
    const utcString = datetime.endsWith('Z') ? datetime : datetime + 'Z';
    return new Date(utcString).toString();
  }
}